import api from "./api";
import imageService from "./imageService";

const clubService = {
  // Get paginated clubs with filtering
  getClubs: async (page = 0, size = 10, search = "", campusId = "") => {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        size: size.toString(),
      });

      if (search) params.append("search", search);
      if (campusId) params.append("campusId", campusId.toString());

      const response = await api.get(`/admin/clubs?${params}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching clubs:", error);
      throw error;
    }
  },

  // Get single club by ID
  getClub: async (id) => {
    try {
      const response = await api.get(`/admin/clubs/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching club:", error);
      throw error;
    }
  },

  // Create new club
  createClub: async (clubData) => {
    try {
      const response = await api.post("/admin/clubs", clubData);
      return response.data;
    } catch (error) {
      console.error("Error creating club:", error);
      throw error;
    }
  },

  // Update existing club
  updateClub: async (id, clubData) => {
    try {
      const response = await api.put(`/admin/clubs/${id}`, clubData);
      return response.data;
    } catch (error) {
      console.error("Error updating club:", error);
      throw error;
    }
  },

  // Delete club
  deleteClub: async (id) => {
    try {
      const response = await api.delete(`/admin/clubs/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting club:", error);
      throw error;
    }
  },

  // Ban club
  banClub: async (id) => {
    try {
      const response = await api.post(`/admin/clubs/${id}/ban`);
      return response.data;
    } catch (error) {
      console.error("Error banning club:", error);
      throw error;
    }
  },

  // Unban club
  unbanClub: async (id) => {
    try {
      const response = await api.post(`/admin/clubs/${id}/unban`);
      return response.data;
    } catch (error) {
      console.error("Error unbanning club:", error);
      throw error;
    }
  },

  // Update member role
  updateMemberRole: async (clubId, userId, roleData) => {
    try {
      const response = await api.put(
        `/admin/clubs/${clubId}/members/${userId}`,
        roleData
      );
      return response.data;
    } catch (error) {
      console.error("Error updating member role:", error);
      throw error;
    }
  },

  // Remove member
  removeMember: async (clubId, userId) => {
    try {
      const response = await api.delete(
        `/admin/clubs/${clubId}/members/${userId}`
      );
      return response.data;
    } catch (error) {
      console.error("Error removing member:", error);
      throw error;
    }
  },

  // Delete event
  deleteEvent: async (clubId, eventId) => {
    try {
      const response = await api.delete(
        `/admin/clubs/${clubId}/events/${eventId}`
      );
      return response.data;
    } catch (error) {
      console.error("Error deleting event:", error);
      throw error;
    }
  },

  // Upload photo
  uploadPhoto: async (file) => {
    return imageService.uploadPhoto(file);
  },

  // Add member to club
  addMember: async (clubId, memberData) => {
    try {
      const response = await api.post(
        `/admin/clubs/${clubId}/members`,
        memberData
      );
      return response.data;
    } catch (error) {
      console.error("Error adding member:", error);
      throw error;
    }
  },

  // Get club memberships
  getClubMemberships: async (clubId, page = 0, size = 10, search = "") => {
    try {
      const params = new URLSearchParams({
        clubId: clubId.toString(),
        page: page.toString(),
        size: size.toString(),
      });

      if (search) params.append("search", search);

      const response = await api.get(
        `/memberships/get-club-memberships?${params}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching club memberships:", error);
      throw error;
    }
  },
};

export default clubService;
